import React, { useRef, useEffect } from 'react';

function useOutsideAlerter(ref, setShowCart, showPromo) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      console.log('CLicked outsite');
      if (ref.current && !ref.current.contains(event.target)) {
        if (!showPromo) {
          setShowCart(false);
        }
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, showPromo]);
}

/**
 * Component that alerts if you click outside of it
 */
export default function ClickOutSideDiv(props) {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, props.setShowCart, props.showPromo);

  return <div ref={wrapperRef}>{props.children}</div>;
}
